import React from 'react';
import { US, EU } from 'country-flag-icons/react/1x1';
import { isCryptoCurrency, TokenLogoMap } from 'features/bill/lib';

export const CurrencyIcon: React.FC<{ currency: string }> = ({ currency }) => {
  let src = '';

  if (isCryptoCurrency(currency)) {
    src = TokenLogoMap[currency];
  } else if (currency === 'USD') {
    return <US className="w-4 rounded-full" />;
  } else if (currency === 'EUR') {
    return <EU className="w-4 rounded-full" />;
  }

  return (
    <div className="h-4 w-4">
      <img src={src} alt="" aria-hidden="true" />
    </div>
  );
};
